module.exports = __webpack_public_path__ + "static/media/3D打印植物监测器.1acf4832.png";